import {
   Line,
   LineChart,
   ResponsiveContainer,
   Tooltip,
   XAxis,
   ReferenceArea,
} from 'recharts'

export const WorkingHours = ({
   bestTime,
   callSummary = [],
}: {
   bestTime?: { startTime: string; endTime: string; day: string }
   callSummary?: any
}) => {
   console.log('callSummary', callSummary, bestTime)
   // Define colors for each day
   const LINE_COLORS = {
      monday: '#9061DA', // Purple
      tuesday: '#FF6B6B', // Coral
      wednesday: '#4ECDC4', // Turquoise
      thursday: '#FFD93D', // Yellow
      friday: '#95E1D3', // Mint
      saturday: '#FF8B94', // Pink
      sunday: '#6C5CE7', // Indigo
   }

   // Create a reusable Line component configuration
   const createLineConfig = (dataKey: string) => ({
      type: 'monotone' as const,
      dataKey,
      stroke: LINE_COLORS[dataKey as keyof typeof LINE_COLORS],
      strokeWidth: 2,
      activeDot: { r: 5 },
      dot: { r: 0 },
      opacity: 0.7,
   })

   // Static data based on the provided table
   const staticData = [
      {
         hour: '8 AM',
         hourIndex: 0,
         monday: 15,
         tuesday: 17,
         wednesday: 19,
         thursday: 20,
         friday: 14,
         saturday: 23,
      },
      {
         hour: '9 AM',
         hourIndex: 1,
         monday: 18,
         tuesday: 20,
         wednesday: 22,
         thursday: 23,
         friday: 17,
         saturday: 25,
      },
      {
         hour: '10 AM',
         hourIndex: 2,
         monday: 14,
         tuesday: 15,
         wednesday: 18,
         thursday: 19,
         friday: 16,
         saturday: 20,
      },
      {
         hour: '11 AM',
         hourIndex: 3,
         monday: 10,
         tuesday: 12,
         wednesday: 14,
         thursday: 13,
         friday: 12,
         saturday: 16,
      },
      {
         hour: '12 PM',
         hourIndex: 4,
         monday: 7,
         tuesday: 8,
         wednesday: 9,
         thursday: 8,
         friday: 7,
         saturday: 10,
      },
      {
         hour: '1 PM',
         hourIndex: 5,
         monday: 8,
         tuesday: 9,
         wednesday: 10,
         thursday: 9,
         friday: 7,
         saturday: 12,
      },
      {
         hour: '2 PM',
         hourIndex: 6,
         monday: 9,
         tuesday: 10,
         wednesday: 11,
         thursday: 10,
         friday: 9,
         saturday: 14,
      },
      {
         hour: '3 PM',
         hourIndex: 7,
         monday: 11,
         tuesday: 13,
         wednesday: 15,
         thursday: 14,
         friday: 11,
         saturday: 17,
      },
      {
         hour: '4 PM',
         hourIndex: 8,
         monday: 17,
         tuesday: 19,
         wednesday: 21,
         thursday: 22,
         friday: 16,
         saturday: 18,
      },
      {
         hour: '5 PM',
         hourIndex: 9,
         monday: 20,
         tuesday: 22,
         wednesday: 25,
         thursday: 26,
         friday: 19,
         saturday: 22,
      },
      {
         hour: '6 PM',
         hourIndex: 10,
         monday: 16,
         tuesday: 18,
         wednesday: 20,
         thursday: 21,
         friday: 15,
         saturday: 19,
      },
   ]

   // Use static data instead of transformed dynamic data
   const data = staticData

   const CustomTooltip = ({ active, payload, label }: any) => {
      if (!active || !payload || !payload.length) return null

      // Find the day with the highest value at this time point
      const activeDay = payload.reduce((max: any, current: any) =>
         current.value > max.value ? current : max
      )

      return (
         <div className="p-2 bg-gray-800 border border-gray-600 rounded custom-tooltip">
            <p className="text-sm text-white">{`${label}`}</p>
            <p
               className="text-sm font-medium capitalize"
               style={{ color: activeDay.color }}
            >
               {`${activeDay.name}: ${activeDay.value}%`}
            </p>
         </div>
      )
   }

   return (
      <div className="bg-[#3B3C42] h-full rounded">
         <p className="px-8 py-5 border-b border-white/20 text-[14px] font-medium flex items-center justify-between">
            <span>Working Hours</span>
            {/* <span className="font-semibold">9:30 am to 5:30 pm MST</span> */}
         </p>
         <div className="flex flex-col py-4 px-7 gap-y-2">
            <p className="text-[14px] text-white/70">
               Best time to call your leads are during <br />
               <span className="font-semibold text-white">
                  8:00-10:00 am
               </span>{' '}
               and{' '}
               <span className="font-semibold text-white">5:00-8:00 pm</span>
            </p>
            <ResponsiveContainer width={'100%'} height={200}>
               <LineChart
                  height={200}
                  data={data}
                  margin={{
                     top: 5,
                     right: 15,
                     left: 15,
                     bottom: 0,
                  }}
               >
                  <XAxis
                     dataKey="hour"
                     strokeWidth={0}
                     opacity={0.5}
                     interval={1}
                     color="#fff"
                     tick={{ fill: '#fff', fontSize: 12 }}
                     tickLine={false}
                     axisLine={false}
                  />
                  <Tooltip
                     content={<CustomTooltip />}
                     cursor={{
                        stroke: '#ffffff',
                        strokeWidth: 1,
                        strokeOpacity: 0.5,
                     }}
                  />

                  {/* Highlight peak time zones */}
                  <ReferenceArea
                     x1="8 AM"
                     x2="10 AM"
                     fill="#ffffff"
                     fillOpacity={0.1}
                  />
                  <ReferenceArea
                     x1="4 PM"
                     x2="6 PM"
                     fill="#ffffff"
                     fillOpacity={0.1}
                  />

                  {Object.keys(LINE_COLORS).map((day) => (
                     <Line key={day} {...createLineConfig(day)} />
                  ))}
               </LineChart>
            </ResponsiveContainer>
         </div>
      </div>
   )
}
